"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    PromoBanner: ()=>PromoBanner
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
require("react");
const index_cjs_namespaceObject = require("../../utils/index.cjs");
const external_Badge_index_cjs_namespaceObject = require("../Badge/index.cjs");
const external_Button_index_cjs_namespaceObject = require("../Button/index.cjs");
const external_Disc_index_cjs_namespaceObject = require("../Disc/index.cjs");
const external_Heading_index_cjs_namespaceObject = require("../Heading/index.cjs");
const external_Image_index_cjs_namespaceObject = require("../Image/index.cjs");
const external_Text_index_cjs_namespaceObject = require("../Text/index.cjs");
const external_PromoBanner_variants_cjs_namespaceObject = require("./PromoBanner.variants.cjs");
function PromoBanner({ badge, body, discIcon, discImage, emphasis = 'regular', handleClick, header, image, palette = 'neutral', primaryActionLabel, secondaryActionClickHandler, secondaryActionLabel }) {
    const { baseSlot, ctaContainerSlot, mainContentContainerSlot, mainContentandCTAContainerSlot, mediaContainerSlot } = (0, external_PromoBanner_variants_cjs_namespaceObject.promoBannerVariants)({
        palette,
        emphasis
    });
    let media = null;
    const bannerEmphasisToUse = 'regular' === emphasis ? 'medium' : 'regular';
    const primaryCtaBtnType = 'regular' === emphasis ? 'tertiary' : 'primary';
    const mediaContainerPadding = image ? '' : 'pl-3';
    if (image) media = /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Image_index_cjs_namespaceObject.Image, {
        src: image,
        alt: 'MediaImage',
        objectFit: "cover",
        className: "h-full w-auto"
    });
    if (discImage) media = /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Disc_index_cjs_namespaceObject.Disc, {
        content: discImage,
        contentType: "imgFill",
        palette: palette,
        emphasis: bannerEmphasisToUse,
        alt: 'DiscImage'
    });
    if (discIcon) media = /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Disc_index_cjs_namespaceObject.Disc, {
        content: discIcon,
        contentType: "icon",
        palette: palette,
        emphasis: bannerEmphasisToUse,
        alt: 'DiscIcon'
    });
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
        className: baseSlot(),
        onClick: ()=>handleClick?.(),
        onKeyDown: (e)=>{
            if ('Enter' === e.key || ' ' === e.key) {
                e.preventDefault();
                e.stopPropagation();
                handleClick?.();
            }
        },
        role: "button",
        tabIndex: 0,
        children: [
            media && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                className: (0, index_cjs_namespaceObject.cn)(mediaContainerSlot(), mediaContainerPadding),
                children: media
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                className: mainContentandCTAContainerSlot(),
                children: [
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                        className: mainContentContainerSlot(),
                        children: [
                            badge && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                                className: "flex",
                                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Badge_index_cjs_namespaceObject.Badge, {
                                    palette: palette,
                                    emphasis: bannerEmphasisToUse,
                                    children: badge
                                })
                            }),
                            header && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Heading_index_cjs_namespaceObject.Heading, {
                                as: "h5",
                                children: header
                            }),
                            body && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Text_index_cjs_namespaceObject.P, {
                                textStyle: "body2",
                                children: body
                            })
                        ]
                    }),
                    (primaryActionLabel || secondaryActionLabel) && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                        className: ctaContainerSlot(),
                        children: [
                            secondaryActionLabel && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Button_index_cjs_namespaceObject.Button, {
                                emphasis: emphasis,
                                onClick: secondaryActionClickHandler,
                                size: "sm",
                                type: "tertiary",
                                children: secondaryActionLabel
                            }),
                            primaryActionLabel && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Button_index_cjs_namespaceObject.Button, {
                                emphasis: emphasis,
                                onClick: handleClick,
                                size: "sm",
                                type: primaryCtaBtnType,
                                children: primaryActionLabel
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
exports.PromoBanner = __webpack_exports__.PromoBanner;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "PromoBanner"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
